import {lazy} from 'react';

export const BoxContainerConfigLazy = lazy(() => import(/* webpackChunkName: "boxContainerConfig" */ '.'));
